import React, { forwardRef, type ComponentProps } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Overlay } from '@radix-ui/react-dialog';

export type ModalOverlayT = ComponentProps<typeof Overlay>;

export const ModalOverlay = forwardRef<HTMLDivElement, ModalOverlayT>(
  (props, ref) => {
    const defaultClasses = [
      'bg-bg-overlay',
      'top-0',
      'right-0',
      'bottom-0',
      'left-0',
      'fixed',
      'z-modal',
      'data-[state=open]:motion-safe:animate-[fadeIn_300ms_ease-out]',
      'data-[state=closed]:motion-safe:animate-[fadeOut_300ms_ease-out]',
    ];

    const { className, ...rest } = props;

    return (
      <Overlay {...rest} ref={ref} className={cn(defaultClasses, className)} />
    );
  },
);
